import React from 'react';
// import { Link } from 'react-router-dom';
import notes from './../../../assets/img/brand/pzu/notes.png';
import mail from './../../../assets/img/brand/pzu/mail.png';

const Refundacja = (props) => {
  return (
    <React.Fragment>
      <div className="text-white p-2 sixthColor iconFromLeft moneyIcon mt-4">
        <h5 className="firstColor">
          <b>Refundacja świadczeń zdrowotnych w TUW PZUW</b>
        </h5>
      </div>
      <div className="secondColor mt-4 ml-5 ">
        <b className="firstColor">
          Możesz skorzystać ze świadczeń zdrowotnych poza siecią placówek
          medycznych PZU Zdrowie.
        </b>
        <br />

        <p className="mt-2">
          Jeśli dane świadczenie medyczne znajduje się w zakresie ubezpieczenia
          (<b>jest bezpłatne</b>) możesz otrzymać zwrot 70% kosztów wskazanych
          na fakturze lub rachunku z limitem do 2 000 zł na każdą uprawnioną
          osobę w ciągu roku (rok polisowy liczony od początku umowy
          ubezpieczeniowej do jej rocznicy).
        </p>

        <b className="firstColor">
          Możesz również skorzystać z opcji zwrotu kosztów
        </b>
        <br />
        <p className="mt-2">
          W przypadku niezapewnienia realizacji świadczeń w zagwarantowanych w
          umowie terminach przysługuje prawo do zwrotu poniesionego kosztu w
          związku z realizacją świadczenia we własnym zakresie. Warunkiem w/w
          zwrotu jest kontakt z infolinią i uzyskanie numeru ZA (promesy) i
          odpowiednie zgłoszenie do TUW PZUW.
        </p>

        <div class="container mt-4">
          <div class="row">
            <div class="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={notes} alt="notes" />
            </div>
            <div class="col-sm-11">
              Aby uzyskać zwrot poniesionych kosztów, dostarcz do TUW PZUW
              następujące dokumenty:
            </div>
          </div>
        </div>

        <ul className="ok ml-5 mt-2">
          <li>formularz zgłoszeniowy,</li>
          <li>
            oryginał imiennej faktury lub rachunku za zrealizowane świadczenie
            zdrowotne,
          </li>
          <li>
            kopię skierowania lekarskiego na usługi, na które skierowanie jest
            wymagane, np. USG, RTG, EMG, EEG, badania laboratoryjne, badania
            hormonalne, rezonansu magnetycznego, tomografii komputerowej,
            biopsji, badania endoskopowe, EKG, Echo serca, testy alergiczne,
            audiometria, densytometrii, urografii, zabiegi rehabilitacji
            ambulatoryjnej.
          </li>
        </ul>

        <div className="ml-5 mt-3">
          <p>Faktura powinna zawierać:</p>
          <ul className="ok">
            <li>Twoje imię i nazwisko,</li>
            <li>nazwę wykonanego świadczenia zdrowotnego,</li>
            <li>cenę każdego świadczenia zdrowotnego,</li>
            <li>datę realizacji usługi medycznej.</li>
          </ul>
        </div>

        <div class="container mt-4">
          <div class="row">
            <div class="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={mail} alt="mail" />
            </div>
            <div class="col-sm-11">
              Wypełniony formularz wraz ze wszystkimi załącznikami możesz nam
              dostarczyć:
            </div>
          </div>
        </div>

        <ul className="ok ml-5 mt-2">
          <li>
            przez serwis mojePZU – w sekcji „Opieka medyczna" w zakładce
            „Refundacje i zwroty",
          </li>
          <li>
            w formie skanu na adres:{' '}
            <b className="firstColor">
              <a
                href="mailto:zwroty_refundacje@pzu.pl"
                target="_blank"
                rel="noopener noreferrer">
                zwroty_refundacje@pzu.pl
              </a>
            </b>
            ,
          </li>
          <li>
            za pośrednictwem strony{' '}
            <b className="firstColor">tvp-tuwpzuw.uspartner.pl</b>, w sekcji
            refundacje w zakładce "refundacje świadczeń 70%" albo "zwrot kosztów
            100%";
          </li>
          <li>
            listownie lub w innej formie, która ma potwierdzenie nadania
            przesyłki (np. przesyłką kurierską) na adres: ul. Postępu 18a,
            02-676 Warszawa, z dopiskiem „Refundacja – TUW Polski Zakład
            Ubezpieczeń Wzajemnych".
          </li>
        </ul>
      </div>

      {/* <div className="text-center mt-5">
        <Link
          to="/36c1b229-f238-4da1-8513-3617faf28bf9"
          className="btn btn-lg btn-primary">
          Wypełnij wniosek refundacji
        </Link>
      </div> */}
    </React.Fragment>
  );
};

export default Refundacja;
